import { alpha, useTheme } from '@mui/material/styles';
import { Colors } from '../../assets/theme/Colors';
import loginBackground from '../../assets/images/login-background.jpeg';

export const useFormStyles = () => {
  const theme = useTheme();

  return ({
    loginFormWrapper: {
      padding: `${theme.spacing(2)} 0 !important `,
      [theme.breakpoints.down('md')]: {
        paddingTop: `0 !important `,
        maxWidth: '444px',
        width: '100%',
      },
      [theme.breakpoints.up('lg')]: {
        width: '400px',
      },
    },
    paper: {
      [theme.breakpoints.up('sm')]: {
        marginTop: theme.spacing(8),
      },
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    avatar: {
      margin: theme.spacing(1),
    },
    form: {
      width: '100%', // Fix IE 11 issue.
    },
    frusLogo: {
      width: 40,
      height: 40,
    },
    submitButton: {
      backgroundColor: Colors.appBar.main,
      '&:hover': {
        backgroundColor: Colors.appBar.light,
      },
      '&:disabled': {
        color: alpha(Colors.white, 0.5),
        backgroundColor: alpha(Colors.appBar.main, 0.5),
      },
      [theme.breakpoints.up('sm')]: {
        margin: theme.spacing(2, 0, 3),
      },
      margin: theme.spacing(1, 0, 2),
      padding: '12px',
    },
    googleButton: {
      [theme.breakpoints.up('sm')]: {
        margin: theme.spacing(1, 0, 2),
      },
      margin: theme.spacing(1, 0, 1),
      background: Colors.blue.main,
      '&:hover': {
        background: Colors.blue.light,
      },
    },
    appleButton: {
      [theme.breakpoints.up('sm')]: {
        margin: theme.spacing(3, 0, 1),
      },
      margin: theme.spacing(2, 0, 1),
      background: '#000',
      '&:hover': {
        background: '#333',
      },
    },
    helpText: {
      padding: theme.spacing(0, 1),
      color: Colors.white,
    },
    logoWrapper: {
      display: 'flex',
      justifyContent: 'center',
      paddingLeft: '0px !important',
      [theme.breakpoints.up('md')]: {
        paddingTop: '0px !important',
      },
    },
    logo: {
      height: '120px',
      [theme.breakpoints.down('md')]: {
        height: '80px',
        my: 2,
      },
    },
    headerText: {
      ...theme.typography['h5'],
      color: `${Colors.white} !important`,
      textAlign: 'center',
      fontWeight: 600,
    },
    pageContainer: {
      backgroundColor: alpha(Colors.primaryColor, 0.8),
      position: 'relative',
      display: 'flex',
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      marginLeft: theme.spacing(-1),
      padding: theme.spacing(0, 2),
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      },
      [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
        justifyContent: 'space-around',
        alignItems: 'center',
      },
    },
    pageBackground: {
      position: 'inherit',
      '&::before': {
        content: "' '",
        display: 'block',
        position: 'fixed',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        backgroundImage: `url(${loginBackground})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '50% 0',
        backgroundSize: 'cover',
      },
    },
    input: {
      '& .MuiInputBase-adornedEnd': {
        background: 'rgb(250, 255, 250)',
      },
      '& input': {
        borderRadius: '4px',
        background: 'rgb(250, 255, 250)',
        WebkitBoxShadow: '0 0 0 100px rgb(250, 255, 250) inset',
      },
      '& input:focus': {
        WebkitBoxShadow: '0 0 0 100px rgb(250, 255, 250) inset',
      },
      '& input:invalid': {
        WebkitBoxShadow: '0 0 0 100px rgb(250, 255, 250) inset',
      },
    },
  });
};
